function getStateAfterAllSystemStatementsUpdated(state, action) {
	return state.merge(
		{
			systemStatementsByQuarterNum: {
				[action.quarterNum]: {
					'incomeStatement': action.updatedIncomeStatement,
					'balanceSheet': action.updatedBalanceSheet,
					'equityStatement': action.updatedEquityStatement,
					'financialRatios': action.updatedFinancialRatios,
				}
			},
			canSubmitFinancialStatements: true,
			isFinancialStatementsAutomatedByQuarter: {
				[action.quarterNum]: action.isFinancialStatementsAutomatedForQuarter
			},
			isFinancialRatiosAutomatedByQuarter: {
				[action.quarterNum]: action.isFinancialRatiosAutomatedForQuarter
			}
		}, { deep: true });
}

function getStateAfterSystemBalanceSheetUpdate(state, action) {
	return getStateFor(state, action.quarterNum,
		'balanceSheet', action.updatedBalanceSheet);
}

function getStateFor(state, quarterNum, key, value) {
	return state.merge(
		{
			systemStatementsByQuarterNum: {
				[quarterNum]: {
					[key]: value
				}
			}
		}, { deep: true });
}


export {
	getStateAfterAllSystemStatementsUpdated,
	getStateAfterSystemBalanceSheetUpdate,
};
